var map = {
	"./btc.webp": 10,
	"./doge.webp": 1682,
	"./eth.webp": 9934,
	"./giftcards.webp": 4584,
	"./ltc.webp": 9404,
	"./mastercard.webp": 8647,
	"./paypal.webp": 5272,
	"./paysafecard.webp": 152,
	"./rust.webp": 7141,
	"./trx.webp": 803,
	"./usdc.webp": 42,
	"./usdt.webp": 5319,
	"./visa.webp": 22
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1996;